import { createAction } from '@reduxjs/toolkit';
import { SharedNotesCollaborationConfig } from 'features/shared-notes/types';

export const signalingSharedNotesReceived = createAction<SharedNotesCollaborationConfig>(
  'signaling/sharedNotes/notesReceived'
);
